import { useState } from "react";
import { Row, Col, Form, ButtonGroup, Button } from "react-bootstrap";
import CalcShell from "../../components/CalcShell";
import CalcField from "../../components/CalcField";
import { formatINR } from "../../utils/format";

const meta = { slug: "gst", emoji: "🧾", title: "GST Calculator", desc: "Add or remove GST from any amount." };
const SLABS = [5, 12, 18, 28];

function GSTCalculator() {
  const [amount, setAmount] = useState(10000);
  const [rate, setRate] = useState(18);
  const [mode, setMode] = useState("add"); // add = exclusive, remove = inclusive

  let base, gst, total;
  if (mode === "add") {
    base = amount;
    gst = (amount * rate) / 100;
    total = base + gst;
  } else {
    total = amount;
    base = (amount * 100) / (100 + rate);
    gst = total - base;
  }

  return (
    <CalcShell
      meta={meta}
      note={
        <span>
          <strong>Add GST:</strong> amount is the base (GST added on top).{" "}
          <strong>Remove GST:</strong> amount already includes GST, and we extract it.
          GST splits equally into CGST + SGST for intra-state sales.
        </span>
      }
    >
      <Row>
        <Col md={6}>
          <ButtonGroup className="mb-4 w-100">
            <Button variant={mode === "add" ? "success" : "outline-success"} onClick={() => setMode("add")}>
              Add GST
            </Button>
            <Button variant={mode === "remove" ? "success" : "outline-success"} onClick={() => setMode("remove")}>
              Remove GST
            </Button>
          </ButtonGroup>
          <CalcField label="Amount (₹)" value={amount} onChange={setAmount} min={1} max={10000000} step={100} prefix="₹" />
          <Form.Group>
            <Form.Label className="fw-semibold">GST rate</Form.Label>
            <div className="d-flex gap-2">
              {SLABS.map((s) => (
                <Button key={s} variant={rate === s ? "success" : "outline-secondary"} onClick={() => setRate(s)}>
                  {s}%
                </Button>
              ))}
            </div>
          </Form.Group>
        </Col>
        <Col md={6}>
          <div className="fi-calc-result mb-3">
            <div>Total amount</div>
            <div className="big">{formatINR(total)}</div>
          </div>
          <Row className="g-3">
            <Col xs={4}>
              <div className="fi-stat">
                <div className="num">{formatINR(base)}</div>
                <small className="text-muted">Base</small>
              </div>
            </Col>
            <Col xs={4}>
              <div className="fi-stat">
                <div className="num">{formatINR(gst / 2)}</div>
                <small className="text-muted">CGST</small>
              </div>
            </Col>
            <Col xs={4}>
              <div className="fi-stat">
                <div className="num">{formatINR(gst / 2)}</div>
                <small className="text-muted">SGST</small>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </CalcShell>
  );
}

export default GSTCalculator;
